import React, { useEffect } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import LogController from "../../controller/LogController";
import { getLangName, getLangWord, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";

const langList = [0, 1, 2, 3, 4, 5, 6, 7, 8];

const LanguageModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  lang: number;
  setLang: any;
  isInitial: boolean;
  setVisibleGuide: (visibleGuide: boolean) => void;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
    if (oProps.isInitial) {
      oProps.setVisibleGuide(true);
    }
  };

  const selectLang = async (lang: number) => {
    try {
      LogController.click({
        path: "LanguageModal",
        params: "lang",
        params2: getLangName(lang) + " 언어 변경 클릭",
        index: lang,
      });
    } catch (err) {
      console.log(err);
    }
    await AsyncLocalStorage.setItem("lang", JSON.stringify(lang));
    oProps.setLang(lang);
    if (!oProps.isInitial) {
      onCloseModal();
    }
  };

  useEffect(() => {}, [oProps.isVisible]);

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={oProps.isInitial ? () => {} : onCloseModal}
      className="languageModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className={`modal ${oProps.isInitial && "initial"}`}>
          <div className="modal_header">
            <div className="header_title">
              {!oProps.isInitial && (
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_language.svg`}
                  width={24}
                  height={24}
                  alt="ic"
                />
              )}
              <h6>Language</h6>
            </div>
            {!oProps.isInitial && (
              <img
                className="closeIcon"
                onClick={onCloseModal}
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
                alt="ic"
              />
            )}
          </div>
          <div className="modal_content">
            {langList.map((item, index) => (
              <button
                key={index}
                className={`typeButton ${oProps.lang === item && "active"}`}
                onClick={() => selectLang(item)}
              >
                <img
                  className="langIcon"
                  src={`${
                    process.env.PUBLIC_URL
                  }/knockknock/svg/lang/ic_lang_${getLangWord(item)}.svg`}
                  alt="ic"
                />
                {langText.languageModal_lang[item]}
              </button>
            ))}
          </div>
          {oProps.isInitial && (
            <button className="confirmButton" onClick={onCloseModal}>
              OK
            </button>
          )}
        </div>
      </Style>
    </Modal>
  );
};

export default LanguageModal;

const Style = styled.div`
  .modal {
    padding: 25px 24px;
  }

  .modal_header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .header_title {
      margin-left: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      img {
        margin-right: 6px;
      }
    }
    h6 {
      font-size: 24px;
      line-height: 36px;
      font-weight: 200;
      color: #ffffff;
    }
    .closeIcon {
      margin-left: auto;
    }
  }
  .modal_content {
    padding: 32px 0 10px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .typeButton {
    width: 30%;
    margin: 5px;
    padding: 12px 0;
    background: #343434;
    border: 2px solid #e5e5e5;
    border-radius: 10px;
    font-size: 24px;
    line-height: 30px;
    color: #e5e5e5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;

    img {
      height: 32px;
    }
  }
  .typeButton.active {
    background: #4dd2ae;
  }

  .modal.initial {
    padding: 25px 4px;

    .modal_header {
      .header_title {
        margin-left: 0;
      }
    }

    .confirmButton {
      margin: 0 10px;
      width: calc(100% - 20px);
      padding: 12px;
      background: #4dd2ae;
      font-size: 24px;
      line-height: 32px;
      border-radius: 5px;
      color: #ffffff;
      font-weight: 600;
      text-align: center;
    }
  }

  @media (max-width: 700px) {
    .modal {
      padding: 24px 14px;
    }
    .typeButton {
      padding: 6px 0;
      font-size: 16px;
      line-height: 22px;
    }
    .typeButton.active {
      background: #4dd2ae;
    }
    .modal_header {
      h6 {
        font-size: 18px;
        font-weight: 400;
      }
    }
    .modal_content {
      padding: 16px 0 10px 0;
    }
  }
`;
